import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {QbSalesTaxCodeDto} from "../model/QbSalesTaxCodeDto";

class QbSalesTaxCodeSelectController implements IComponentController {
    records: QbSalesTaxCodeDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllQbSalesTaxCode(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.qbSalesTaxCodeSubscribeAndQuery().then(ret=>this.records=ret);
    };

    $onInit(): void {
    }
    $onDestroy?() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.qbSalesTaxCodeSelect', [])
    .component('qbSalesTaxCodeSelect', {
        template: require('./QbSalesTaxCodeSelect.html'),
        controller: QbSalesTaxCodeSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
